import React from 'react'

import { EditLabel } from 'modules/Labels/containers'
import { Layout } from 'components'

const LabelEditPage = () => (
  <Layout>
    <EditLabel />
  </Layout>
)

export default LabelEditPage
